import { gql } from '@apollo/client';

const GET_ASSIGNMENTS = gql`
  query ($where: AssignmentsWhereInput!) {
    assignments(where: $where) {
      id
      title
      character {
        id
        character
      }
      students {
        id
        firstName
        lastName
        groups {
          id
          name
        }
      }
      assignmentActivities {
        id
        activity {
          activityType {
            name
          }
        }
        attempts {
          studentId
          files {
            description
            url
            signedUrl
            mimeType
          }
          status
          assignmentActivityId
        }
      }
      groups {
        id
        name
        groupCategory {
          id
          name
        }
        groupEnrollments {
          student {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;

export default GET_ASSIGNMENTS;
